import React from "react";
import { useInView } from "../hooks/useInView";

const Offer = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const offerCategories = [
    {
      id: 1,
      title: "Pneumatyka",
      accentColor: "bg-[#1748FF]",
      backgroundColorHEX: "bg-[#1748FF1A]",
      items: [
        "Siłowniki",
        "Elektrozawory",
        "Wyspy zaworowe",
        "Przygotowanie powietrza",
        "Technika połączeniowa",
        "Technika próżniowa",
        "Siłowniki elektryczne",
      ],
      image: "/pictures/oferta_pneumatyka.png",
    },
    {
      id: 2,
      title: "Czujniki",
      accentColor: "bg-[#0C9A5F]",
      backgroundColorHEX: "bg-[#0C9A5F14]",
      items: [
        "Indukcyjne",
        "Pojemnościowe",
        "Fotoelektryczne",
        "Ultradźwiękowe",
        "Poziomu",
        "Temperatury",
        "Ciśnienia",
        "Enkodery",
      ],
      image: "/pictures/oferta_czujniki.png",
    },
    {
      id: 3,
      title: "Falowniki",
      accentColor: "bg-[#FFAA00]",
      backgroundColorHEX: "bg-[#FFAA0026]",
      items: ["Skalarne", "Wektorowe", "Serwo", "Softstarty"],
      image: "/pictures/oferta_falowniki.png",
    },
    {
      id: 4,
      title: "Technika napędowa",
      accentColor: "bg-[#009AC9]",
      backgroundColorHEX: "bg-[#009AC914]",
      items: [
        "Silniki",
        "Przekładnie",
        "Motoreduktory",
        "Sprzęgła",
        "Serwonapędy",
      ],
      image: "/pictures/oferta_technika_napedowa.png",
    },
    {
      id: 5,
      title: "Sterowanie i wizualizacja",
      accentColor: "bg-[#7E0DE7]",
      backgroundColorHEX: "bg-[#7E0DE71A]",
      items: [
        "Sterowniki PLC",
        "Panele operatorskie HMI",
        "Moduły programowalne",
      ],
      image: "/pictures/sterowanie-wizualizacja-oferta.png",
    },
    {
      id: 6,
      title: "Bezpieczeństwo",
      accentColor: "bg-[#FFD900]",
      backgroundColorHEX: "bg-[#FFD90014]",
      items: [
        "Kurtyny bezpieczeństwa",
        "Przekaźniki bezpieczeństwa",
        "Wyłączniki drzwiowe",
        "Wyłączniki ryglujące",
        "Wyłączniki magnetyczne",
      ],
      image: "/pictures/oferta_bezpieczenstwo.png",
    },
    {
      id: 7,
      title: "Hydraulika",
      accentColor: "bg-[#0F1523]",
      backgroundColorHEX: "bg-[#0F15230D]",
      items: [
        "Zawory",
        "Rozdzielacze hydrauliczne",
        "Silniki hydrauliczne",
        "Szybkozłącza",
        "Pompy hydrauliczne",
      ],
      image: "/pictures/oferta_hydraulika.png",
    },
    {
      id: 8,
      title: "Aparatura Elektroinstalacyjna",
      accentColor: "bg-[#EB5886]",
      backgroundColorHEX: "bg-[#EB588626]",
      items: [
        "Wyłaczniki silnikowe",
        "Styczniki",
        "Zasilacze impulsowe",
        "Przekaźniki elektroniczne",
        "Szafy sterownicze",
        "Obudowy",
        "Złącza przemysłowe",
        "Przewody elektryczne",
      ],
      image: "/pictures/oferta_aparatura_elektroinstalacyjna.png",
    },
  ];

  return (
    <section id="offer" className="section-padding bg-special1-500">
      <div className="container-custom">
        {/* Header */}

        <div ref={ref} className="mb-16">
          <p
            className={`text-5xl md:text-5xl lg:text-8xl xl:text-8xl text-white max-w-3xl font-heading transition-all duration-700 delay-200 leading-tight pb-3 ${
              inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
            }`}
          >
            Nasza oferta
          </p>
          <h2
            className={`w-8/12 text-sm md:text-base lg:text-xl font-sans font-extralight text-[#E2E3E5] transition-all duration-700 tracking-wider ${
              inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
            }`}
          >
            W naszej ofercie znajdziesz zarówno nowe, jak i trudno dostępne komponenty z zakresu automatyki, pneumatyki, hydrauliki i elektrotechniki przemysłowej.
          </h2>
        </div>

        {/* Desktop Grid Layout */}
        <div className="hidden lg:grid lg:grid-cols-2 lg:gap-4 xl:gap-6">
          {offerCategories.map((category, index) => (
            <div
              key={category.id}
              className={`bg-white rounded-lg overflow-hidden transition-all duration-700 hover:shadow-xl hover:-translate-y-1 ${
                inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
              }`}
              style={{ transitionDelay: `${300 + index * 100}ms` }}
            >
              <div className="p-4 pr-1 sm:p-6 lg:p-8 lg:pr-4 flex flex-col sm:flex-row justify-between gap-4 sm:gap-6">
                {/* Left Content */}
                <div className="flex-1 min-w-0">
                  <div
                    className={`h-1 w-8 sm:w-10 lg:w-12 ${category.accentColor} mb-2`}
                  ></div>
                  <h3 className="text-lg sm:text-xl md:text-2xl lg:text-[32px] font-semibold text-gray-900 mb-3 sm:mb-4 leading-tight">
                    {category.title}
                  </h3>

                  <ul className="flex flex-1 flex-wrap gap-1">
                    {category.items.map((item, itemIndex) => (
                      <li
                        key={itemIndex}
                        className={`text-xs sm:text-sm lg:text-[14px] text-[#0F1523] py-1 px-2 ${category.backgroundColorHEX} transition-colors duration-200 rounded-sm`}
                      >
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Right Image */}
                <div className="flex-1 min-w-0 rounded-lg overflow-hidden flex justify-center items-center">
                  <img
                    src={category.image}
                    alt={category.title}
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Mobile List Layout */}
        <div className="lg:hidden space-y-4">
          {offerCategories.map((category, index) => (
            <div
              key={category.id}
              className={`bg-white rounded-lg shadow-lg overflow-hidden transition-all duration-700 ${
                inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
              }`}
              style={{ transitionDelay: `${300 + index * 100}ms` }}
            >
              <div className="p-4 sm:p-6">
                {/* Header with Title and Placeholder */}
                <div className="flex items-center justify-between mb-4">
                  <div>
                    <div className={`h-1 w-12 ${category.accentColor} mb-2`} />
                    <h3 className="text-2xl sm:text-xl font-semibold text-gray-900">
                      {category.title}
                    </h3>
                  </div>
                  <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-lg overflow-hidden flex-shrink-0 ml-4">
                    <img
                      src={category.image}
                      alt={category.title}
                      className="w-full h-full object-contain"
                    />
                  </div>
                </div>

                {/* Items List */}
                <div className="flex flex-wrap gap-1">
                  {category.items.map((item, itemIndex) => (
                    <div
                      key={itemIndex}
                      className={`text-sm sm:text-base text-[#0F1523] py-1 px-2 ${category.backgroundColorHEX} transition-colors duration-200 cursor-pointer py-1`}
                    >
                      {item}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Offer;
